import type { UseFormReturn } from 'react-hook-form';
import { Badge } from '../../../components/ui/Badge';
import { Section } from '../../../components/ui/Section';
import { str } from '../../../platform/api/utils';
import {
  type EditForm,
  CATEGORY_LABELS,
  PRIORITY_LABELS,
  PRIORITY_VARIANTS,
  STATUS_LABELS,
  STATUS_VARIANTS,
  Field,
  fmtDate,
  dlGrid,
  Dt,
  Dd,
  inputCss,
  primaryBtn,
  secondaryBtn,
} from './task-detail.support';

export function TaskDadosTab(props: {
  editing: boolean;
  form: UseFormReturn<EditForm>;
  t: Record<string, unknown>;
  cat: string;
  pr: string;
  st: string;
  updatePending: boolean;
  onCancelEdit: () => void;
  onSave: (data: EditForm) => void;
}) {
  const { editing, form, t, cat, pr, st, updatePending, onCancelEdit, onSave } = props;
  return (
    <>
      {editing ? (
        <Section title="Editar tarefa">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem 1.5rem' }}>
            <Field label="Título" error={form.formState.errors.title?.message}>
              <input {...form.register('title')} style={inputCss} />
            </Field>
            <div />
            <Field label="Categoria">
              <select {...form.register('category')} style={inputCss}>
                {Object.entries(CATEGORY_LABELS).map(([v, l]) => (
                  <option key={v} value={v}>
                    {l}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Prioridade">
              <select {...form.register('priority')} style={inputCss}>
                {Object.entries(PRIORITY_LABELS).map(([v, l]) => (
                  <option key={v} value={v}>
                    {l}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Vencimento">
              <input {...form.register('dueDate')} type="date" style={inputCss} />
            </Field>
            <div />
            <Field label="Descrição" error={undefined}>
              <textarea
                {...form.register('description')}
                style={{ ...inputCss, minHeight: 60, resize: 'vertical' }}
              />
            </Field>
          </div>
          <div
            style={{
              display: 'flex',
              gap: '0.5rem',
              marginTop: '1rem',
              justifyContent: 'flex-end',
            }}
          >
            <button type="button" onClick={onCancelEdit} style={secondaryBtn}>
              Cancelar
            </button>
            <button
              type="button"
              onClick={() => {
                void form.handleSubmit(onSave)();
              }}
              disabled={updatePending}
              style={primaryBtn}
            >
              {updatePending ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </Section>
      ) : (
        <>
          <Section title="Dados da tarefa">
            <dl style={dlGrid}>
              <Dt>Título</Dt>
              <Dd>{str(t.title)}</Dd>
              <Dt>Categoria</Dt>
              <Dd>{CATEGORY_LABELS[cat] ?? cat}</Dd>
              <Dt>Prioridade</Dt>
              <Dd>
                <Badge
                  label={PRIORITY_LABELS[pr] ?? pr}
                  variant={PRIORITY_VARIANTS[pr] ?? 'default'}
                />
              </Dd>
              <Dt>Situação</Dt>
              <Dd>
                <Badge
                  label={STATUS_LABELS[st] ?? '—'}
                  variant={STATUS_VARIANTS[st] ?? 'default'}
                />
              </Dd>
              <Dt>Vencimento</Dt>
              <Dd>{fmtDate(t.dueDate)}</Dd>
              <Dt>Concluída em</Dt>
              <Dd>{fmtDate(t.completedAt)}</Dd>
              {str(t.eventId) && (
                <>
                  <Dt>Evento vinculado</Dt>
                  <Dd>
                    <code style={{ fontSize: '0.75rem' }}>{str(t.eventId)}</code>
                  </Dd>
                </>
              )}
              {str(t.obligationId) && (
                <>
                  <Dt>Obrigação vinculada</Dt>
                  <Dd>
                    <code style={{ fontSize: '0.75rem' }}>{str(t.obligationId)}</code>
                  </Dd>
                </>
              )}
              {str(t.description) && (
                <>
                  <Dt>Descrição</Dt>
                  <Dd>{str(t.description)}</Dd>
                </>
              )}
            </dl>
          </Section>
          <Section title="Metadados">
            <dl style={dlGrid}>
              <Dt>Criada em</Dt>
              <Dd>{fmtDate(t.createdAt)}</Dd>
              <Dt>Atualizada em</Dt>
              <Dd>{fmtDate(t.updatedAt)}</Dd>
            </dl>
          </Section>
        </>
      )}
    </>
  );
}
